export class OrderDetailModel {
    BettingId: number;
    UserName: string;
    LotteryName: string;
    PlayName: string;
    SelectMedian: string;
    IssueNo: string;
    BettingMoney: number;
    StateName: string;
    GraduationCount: number;
    Reward: number;
    BonusMoney: number;
    IsChaseNo: boolean;
    BuyIssueCount: number;
    CompleteIssueCount: number;
    IsStopAfterWinning: boolean;
    AddTime: string;
    RevocationMoney: number;
    BettingNumber: string;
    LotteryCode: string;
    LotteryTypeCode: string;
    BettingItems: DollarsBetting[];
    Issues: BettingInfoIssue[];
    BettingInfoIssues: BettingInfoList[];
    PlayCode: string;
    PlayModeType: number;
    LotteryPlayModeCode: string;
    LotteryPlayModeName: string;
}

export class BettingInfoList {
    BettingItems: string;
    Reward: number;
    BettingMoney: number;
    PerPrice: number;
    Multiple: number;
    BettingItemCount: number;
    LotteryPlayModeCode: string;
}

export class BettingInfoIssue {
    BettingId: number;
    IssueNo: string;
    Multiple: number;
    PerPrice: number;
    BettingMoney: number;
    Reward: number;
    BonusMoney: number;
    WinningCount: number;
    State: string;
    StateName: string;
    AddTime: string;
    LotteryCode: string;
    OpenNo: string;
}
export class DollarsBetting {
    BettingId: number;
    BettingMoney: number;
    BettingNumber: string;
    LotteryPlayDetailCode: string;
    Position: string;
    Rebate: number;
    SerialNo: number;
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/models/orderdetail.model.ts